import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=4269af52&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4269af52"]])

export default __exports__